export const slideInMenu = {
  comicDetailsMenu: {
    comicDetails: "Series info",
    free: "free",
    nsfw: "nsfw",
    views: "views",
    shelves: "shelves",
    releases: "Releases",
    audience: "audience",
    description: "Description",
    show_more_details: "Show more details",
    hide_details: "Hide details",
    contributors: "Contributors",
    related: "Related",
    continueReading: "Continue reading",
    startReading: "Start reading",
    editComic: "Edit series",
    crowdfundingCta:
      "Help raise <bold> ${{amount}} </bold> for this title on {{service}}",
    emptyReleaseList: "No sign of any releases here",
    alwaysFreeToRead: "Always free to read",
    freeWithAGoldMembership: "Free with a <bold>Gold Membership</bold>",
    collectionOnlyNotIncludedWithGold:
      "<bold>COLLECTION</bold> only - not included with a Gold Membership",
    addToLibrary: "Add to Library",
    removeFromLibrary: "Remove from Library",
    followCreator: "Follow Creator",
    unfollowCreator: "Unfollow Creator",
    share: "Share",
    hideFromReadingHistory: "Hide from Reading History",
    hiddenFromReadingHistory: "Hidden from Reading History",
    comicHiddenFromHistory: "Comic is now hidden from reading history",
    comicVisibleOnHistory: "Comic is now visible on reading history",
    bundles: "Bundles",
    bundlesContainingComic:
      "This release is included for sale in the following bundles",
    noBundlesFound: "No bundles found for this comic.",
    goldClarity_one: "{{count}} book free with Gold",
    goldClarity_other: "{{count}} books free with Gold",
  },
  releaseInfoMenu: {
    releaseInfo: "Release info",
    issue: "Issue",
    share: "Share",
    page: "Page",
    editRelease: "Edit release",
    continueReading: "Continue reading",
    startReading: "Start reading",
    preview: "Preview",
    freeWithGold: "Free with Gold",
    buy: "Buy",
    buyWithGold: "Buy {{price}} with Gold",
    getWithAGoldMembership:
      "Get {{discount}}% off with a GlobalComix Gold membership.",
    youSavedAsAGoldMember: "You saved {{discount}}% as a Gold member!",
    cover: "Cover",
    viewSeriesInfo: "View series info",
    morePages: "{{count}} more pages",

    collectible: "Collectible",
    collectibleTooltip:
      "Collectibles are releases that are not included with a gold membership and must be bought to be read.",
    buyNow: "Buy now",
    bundleIncluded:
      "This release is included for sale in the following bundles",
    bundleNotIncluded: "This release is not included in any bundles.",
  },
  userProfile: {
    memberSince: "Member since",
    completions: "completions",
    readPages: "read pages",
    library: "library",
    following: "following",
    myPages: "My pages",
  },
  bundleDetails: {
    buyBundleNow: "Buy Now",
    discountOff: "{{discountPercentage}}% OFF",
    youOwnAllReleases: "You own all of these releases",
    allReleasesOwned: "All releases owned",
    youOwnSomeReleases: "You already own {{count}} of these books",
    bundleDetails: "Bundle details",
    views: "views",
    releases: "releases",
    series: "series",
    pages: "pages",
    sales: "Sales",
    details: "Details",
    bundles: "Bundles",
  },
};
